module.exports = __webpack_public_path__ + "img/dog_bowl_with_background.ed6f068.svg";